// extracted by mini-css-extract-plugin
module.exports = {"credit-amount":"CreditAmount_credit-amount__1ogZi","credit-amount__balance":"CreditAmount_credit-amount__balance__2Nz5y"};